import { Component } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-pay-online-cancel',
  templateUrl: './pay-online-cancel.component.html'
})

export class PayOnlineCancelComponent {
  public processing: boolean = false;
  public isValid: boolean = true;

  constructor(public sharedService: SharedService) { }
}


